import { WORKING_ORDER } from "constants/action-types";
import { IAddLineItemMeta, IAddLineItemPayload, ISendLineItemResultAction } from "types/working-order/line-items";

export const addLineItem = (payload: IAddLineItemPayload, meta: IAddLineItemMeta) => ({
    type: WORKING_ORDER.LINE_ITEM.ADD.START,
    payload,
    meta,
});

export const sendAddLineItemResult = (
    payload: ISendLineItemResultAction["payload"],
    meta?: ISendLineItemResultAction["meta"],
    error?: Error,
): ISendLineItemResultAction => ({
    type: WORKING_ORDER.LINE_ITEM.SEND_RESULT,
    payload,
    meta,
    error,
});
